import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../../hooks/useAuth';

const SetingsGuard = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { user } = useAuth();
  console.log(user);



    if(user.user_group === "valuator"){
        return <Redirect to="/accessdenied" />;
      }

  return <>{children}</>;
};

SetingsGuard.propTypes = {
  children: PropTypes.node
};

export default SetingsGuard;
